import * as React from 'react';

import { Link } from '@blockworks/ui/legacy/link';

import Breadcrumb, { BreadCrumbItem } from '@/components/display/headers/breadcrumb';

interface SitemapListLayoutProps {
    title: string;
    description?: string;
    path: string;
    breadcrumb: BreadCrumbItem;
    items: SitemapListItem[];
    children?: JSX.Element | React.ReactNode;
}

export type SitemapListItem = {
    slug: string;
    name: string;
    description?: string;
};

const SitemapListLayout = (props: SitemapListLayoutProps) => {
    const { title, description, path, items, breadcrumb } = props;

    return (
        <main className="border-b xl:border-none w-full">
            <div className="p-12 border-b">
                <Breadcrumb
                    items={[
                        {
                            title: 'Site Map',
                            link: '/sitemap',
                        },
                        breadcrumb,
                    ]}
                />
                <div className="">
                    <h1 className="self-stretch w-full text-5xl font-semibold text-left text-[#110b29]">
                        {title} Index
                    </h1>
                    <p className="self-stretch w-full text-xl text-left text-gray-600">{description}</p>
                </div>
            </div>
            <div className="p-12 grid gap-8 grid-cols-1 md:grid-cols-2 xl:grid-cols-3">
                {items.map(item => (
                    <div
                        key={item.slug}
                        className="flex flex-col justify-start items-start self-stretch flex-grow-0 flex-shrink-0 relative gap-1"
                    >
                        <p className="self-stretch text-3xl text-left">
                            <Link href={`${path}/${item.slug}`} className="text-primary hover:text-gray-700">
                                {item.name}
                            </Link>
                        </p>
                        <p className="self-stretch text-md text-left text-gray-600">{item.description}</p>
                    </div>
                ))}
            </div>
        </main>
    );
};

export default SitemapListLayout;
